<template>
  <section style="padding: 0">
    <v-container v-if="loading" class="pa-0" style="text-align: center; height: 100%;">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-container>
    <v-container v-else class="pa-0" v-bind:class="{ full_height: compact }">
      <v-row no-gutters v-bind:class="{ full_height_inner: compact }">
        <v-col sm="12" style="height: 100%">
          <div
            v-bind:class="{ compact }"
            class="chat-container"
            ref="chatContainer"
            id="chatContainer"
          >
            <div
              class="message"
              v-for="(message, index) in messages"
              v-bind:key="index"
              :class="{ own: message.usuario._id == userId }"
            >
              <div v-if="message.usuario._id != userId">
                <div
                  class="username"
                  v-if="
                    index > 0 &&
                      messages[index - 1].usuario._id != message.usuario._id
                  "
                >
                  {{ message.usuario.name }}
                </div>
                <div class="username" v-if="index == 0">
                  {{ message.usuario.name }}
                </div>
              </div>
              <div style="margin-top: 5px"></div>
              <div class="content">
                <div v-html="message.descripcion_comentario"></div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="message-input">
        <v-col sm="12" style="position: relative;">
          <div
            class="d-flex flex-row align-center"
            style="padding-left: 3mm; padding-right: 3mm;"
          >
            <v-text-field
              v-model.trim="message"
              placeholder="Escriba un mensaje..."
              @keypress.enter="sendMessage"
            ></v-text-field>
            <v-btn
              v-show="message != null && message.length > 0"
              :disabled="disabledBtn"
              icon
              class="ml-4"
              @click="sendMessage"
            >
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
export default {
  components: {},
  props: {
    compact: { type: Boolean, default: false }
  },
  data() {
    return {
      requestId: null,
      userId: null,
      message: null,
      messages: [],
      loading: false,
      disabledBtn: false,
      technician: null,
      baseURL: null
    };
  },
  mounted() {
    this.getTechnician();
    this.requestId = this.$route.query.requestId;
    this.userId = this.technician && this.technician.user;
    this.baseURL = JSON.parse(localStorage.getItem("baseURL"));
    this.$store.commit("set_app_title", `#${this.requestId}`);
    this.getMessagesList();
  },

  watch: {
    "$store.state.message_chat": function(val, old) {
      let message_chat = JSON.parse(JSON.stringify(val));
      if (message_chat != null) {
        const notification = JSON.parse(message_chat.notification);
        const chat = JSON.parse(message_chat.chat);
        if (notification.request == this.requestId) {
          this.messages.push(chat);
          localStorage.setItem(
            `chat-${this.requestId}-${this.userId}`,
            JSON.stringify(this.messages)
          );
          this.scrollTop();
        }
      }
    }
  },

  methods: {
    getTechnician: function() {
      this.technician = JSON.parse(localStorage.getItem("technician"));
    },

    getMessagesList() {
      let messages = JSON.parse(
        localStorage.getItem(`chat-${this.requestId}-${this.userId}`)
      );
      if (messages == null) {
        this.loading = true;
      } else {
        this.messages = messages;
        this.scrollTop();
      }
      this.axios
        .get(`${this.baseURL}chat/${this.requestId}-${this.userId}/?top=5`)
        .then(response => {
          this.messages = response.data;
          localStorage.setItem(
            `chat-${this.requestId}-${this.userId}`,
            JSON.stringify(this.messages)
          );
          this.loading = false;
          this.scrollTop();
        })
        .catch(() => {
          console.log("error al obtener mensajes");
          this.loading = false;
        });
    },

    sendMessage() {
      if (this.message == null || this.message.length == 0) return;
      const body = { descripcion_comentario: this.message };
      this.disabledBtn = true;
      this.axios
        .post(`${this.baseURL}chat/${this.requestId}-${this.userId}/`, body)
        .then(response => {})
        .catch(() => {
          console.log("error al obtener tecnico");
        });
      this.messages.push({
        id: null,
        descripcion_comentario: this.message,
        created_time: null,
        usuario: {
          _id: this.userId
        }
      });
      this.disabledBtn = false;
      this.message = null;
      this.scrollTop();
    },

    scrollTop() {
      setTimeout(() => {
        let element = document.getElementById("chatContainer");
        if (element != null) {
          element.scrollTop = element.scrollHeight;
        }
      }, 200);
    }
  }
};
</script>
<style scoped>
@media (max-width: 959px) {
  .chat-container {
    height: calc(100vh - 80px);
    position: fixed;
    top: 60px;
    left: 0;
  }
  .message-input {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 70px;
    padding-top: 10px;
  }
}

.chat-container {
  box-sizing: border-box;
  overflow-y: auto;
  padding: 10px;
  background-color: #ffffff;
  max-height: 82vh;
}
.full_height {
  height: 100vh;
}
.full_height_inner {
  height: 82vh;
  background: blue;
}
.compact {
  height: 150vh;
}
.message {
  margin-bottom: 3px;
}
.message.own {
  text-align: right;
}
.message.own .content {
  background-color: #607d8b;
  color: white;
}
.chat-container .username {
  font-size: 13px;
  font-weight: bold;
  margin-top: 16px;
}
.chat-container .content {
  padding: 8px;
  background-color: #eeeeee;
  border-radius: 5px;
  display: inline-block;
  font-size: 16px;
  /* box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12); */
  max-width: 80%;
  word-wrap: break-word;
}

@media (max-width: 480px) {
  .chat-container .content {
    max-width: 60%;
  }
}
</style>
